/*
 * @Author: Jun
 * @Date: 2021-03-24 16:48:06
 * @LastEditTime: 2021-03-24 16:50:10
 * @LastEditors: JUN
 * @Description:
 * @FilePath: /guokr-ad/src/views/CC/index.tsx
 */
import { makeStyles, Theme } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Tab from "@material-ui/core/Tab"
import Tabs from "@material-ui/core/Tabs"
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation'
import ListAltIcon from '@material-ui/icons/ListAlt'
import SwipeViews from "react-swipeable-views"
import React, { Fragment, useState, useContext } from "react"
import { AppContext } from "../Home/context"
import Calendar from "Components/Calendar"
import TabPanel from "./TabPanel"
import { ChildrenCalendarTab } from "Types/app"
const tabArray: ChildrenCalendarTab[] = [
    {
        value: "child_board",
        text: "童学馆日历",
        icon: <InsertInvitationIcon/>,
    }, {
        value: "child_article_type",
        text: "文章类型",
        icon: <ListAltIcon/>,
    },
]
const useStyles = makeStyles((theme: Theme) => ({
    "@global": {
        "#root": {
            display: "flex",
        },
    },
    root: {
        backgroundColor: theme.palette.background.paper,
    },
    tabIndicator: {
        height: 0,
    },
    tabItem: {
        lineHeight: 1,
        marginTop: 4,
        borderRadius: theme.shape.borderRadius,
        fontSize: 14,
        minHeight: 0,
    },
    selectedItem: {
        backgroundColor: "#ff9800",
        color: "white",
        borderWidth: 0,
    },
}))

export default function ChildrenCalendar() {
    const classes = useStyles()
    const [ index, setIndex ] = useState(0)

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setIndex(newValue)
    }
    const handleChangeIndex = (index: number) => {
        setIndex(index)
    }
    const { privilegeMap, user } = useContext(AppContext)
    return (
        <div className={classes.root}>
            <Tabs
                value={index}
                onChange={handleChange}
                classes={{
                    indicator: classes.tabIndicator,
                }}
                centered
            >
                {
                    tabArray.map((tab: ChildrenCalendarTab, index) => (
                        <Tab
                            label={tab.text}
                            icon={tab.icon}
                            key={tab.value}
                            value={index}
                            classes={{
                                root: classes.tabItem,
                                selected: classes.selectedItem,
                            }}
                        />
                    ))
                }
            </Tabs>
            <SwipeViews
                index={index}
                onChangeIndex={handleChangeIndex}
            >
                {
                    tabArray.map((tab: ChildrenCalendarTab, index) => {
                        switch (tab.value) {
                            case 'child_board':

                                return (
                                    <Fragment>
                                        <Calendar channelName={'童学馆'}/>

                                        <Typography component="div">
                                            <pre style={{whiteSpace: 'pre-line'}}>
                                                预约规则：<br/>
                                                果壳童学馆每日推送一次，发布时间 ：早7:30<br/>
                                                1.电商每周固定占周一至周五头条卖货；<br/>
                                            </pre>
                                        </Typography>
                                    </Fragment>
                                )

                            default:
                                return (
                                    <TabPanel tab={tab} index={index} key={index} privilegeMap={privilegeMap}/>
                                )
                        }
                    })
                }
            </SwipeViews>
            <div id="board_input_modal" />
            <div id="child_article_type_modal" />
        </div>
    )
}
